import React from 'react';
import { Dialog, Slide, useMediaQuery, useTheme } from '@mui/material';

// Full-screen page on mobile, centered modal on desktop (≥ md). Each sheet
// keeps the same children — only the outer container swaps.
//
// Mobile used to be a bottom Drawer capped at 92vh. That capped height was
// the source of two bugs on phones: the Autocomplete popper for a long list
// (customers, employees, categories) opened inside a container that was
// already nearly full and had its own scroll, so the dropdown fought the
// sheet for scrolling and options ended up clipped or off-screen — worse
// once the on-screen keyboard claimed the bottom half. Going full-screen
// gives the popper the whole viewport, so it behaves like a normal page.
//
// Children render their own header; `useSheetFullScreen()` lets them show a
// back arrow instead of a close X when they're presented as a page.

const SlideUp = React.forwardRef(function SlideUp(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

// True when the sheet is presented as a full-screen page (mobile).
export function useSheetFullScreen() {
  const theme = useTheme();
  return !useMediaQuery(theme.breakpoints.up('md'));
}

export default function ResponsiveSheet({
  open,
  onClose,
  children,
  maxWidth = 'sm',
}) {
  const fullScreen = useSheetFullScreen();

  return (
    <Dialog
      open={open}
      onClose={onClose}
      fullScreen={fullScreen}
      maxWidth={maxWidth}
      fullWidth={!fullScreen}
      TransitionComponent={fullScreen ? SlideUp : undefined}
      PaperProps={{
        sx: fullScreen
          ? { borderRadius: 0 }
          : { borderRadius: 2, maxHeight: '90vh' },
      }}
    >
      {children}
    </Dialog>
  );
}
